import {
  LOAD_CUSTOMERS,
  CustomersState,
  CustomerAction,
  FETCH_CUSTOMERS,
  REMOVE_CUSTOMER,
  PERSIST_CUSTOMER,
  SET_CUSTOMERS_DATE_FILTER,
} from "./CustomerTypes";
import { Customer } from "msd-capacity-planning-model";
import { dateFilterStorage } from "../utils/dateFilterStorage";
const initialState: CustomersState = {
  items: {},
  synching: true,
  dateFilter: dateFilterStorage.get() || undefined,
};

export default function customersReducer(
  state = initialState,
  action: CustomerAction
): CustomersState {
  switch (action.type) {
    case FETCH_CUSTOMERS:
      return {
        ...state,
        synching: true,
      };
    case REMOVE_CUSTOMER:
      return {
        ...state,
        synching: true,
      };
    case PERSIST_CUSTOMER:
      return {
        ...state,
        synching: true,
      };

    case LOAD_CUSTOMERS: {
      const dateFilter = action.dateFilter || state.dateFilter;
      const filterDate = dateFilter ? new Date(dateFilter) : (() => {
        const oneYearAgo = new Date();
        oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
        return oneYearAgo;
      })();

      return {
        ...state,
        items: action.items.reduce((all: { [id: string]: Customer }, team) => {
          // Only add the customer if they don't have an offboardingDate or it's after the filter date
          if (!team.offboardingDate || (
            team.offboardingDate &&
            new Date(team.offboardingDate.year, team.offboardingDate.month, team.offboardingDate.day) >= filterDate
          )) {
            all[team.id] = team;
          }
          return all;
        }, {}),
        synching: false,
        dateFilter,
      };
    }
    case SET_CUSTOMERS_DATE_FILTER: {
      // Save to localStorage
      dateFilterStorage.set(action.dateFilter);
      return {
        ...state,
        dateFilter: action.dateFilter,
      };
    }
    default:
      return state;
  }
}
